import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// ------------------------Get Order-------------------
export const getOrderApi = async (data) => {
  const endPoint =
    `order` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
// ------------------------- order detail------------
export const orderDetailApi = async (id) => {
    const endPoint = `order/${id}`;
    return await axios.get(endPoint, setJwtToken());
};

export const changeOrderStatus = async (data) => {
    const endPoint = `order`;
    return await axios.put(endPoint, data, setJwtToken());
  };
  